import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    date: "2018",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    date: "2019",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    date: "2020",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    date: "2021",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    date: "2022",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
];

const monthTickFormatter = (tick: any) => {
  const date = new Date(tick);

  return date.getMonth() + 1;
};

const YearlyChart = (tickProps: any) => {
  const { x, y, payload } = tickProps;
  const { value, offset } = payload;
  const date = new Date(value);
  const month = date.getMonth();
  const quarterNo = Math.floor(month / 3) + 1;
  const isMidMonth = month % 3 === 1;

  if (month % 3 === 1) {
    return <text x={x} y={y - 4} textAnchor="middle">{`Q${quarterNo}`}</text>;
  }

  const isLast = month === 11;

  if (month % 3 === 0 || isLast) {
    const pathX = Math.floor(isLast ? x + offset : x - offset) + 0.5;

    return <path d={`M${pathX},${y - 4}v${-35}`} stroke="red" />;
  }
  return null;
};
export default class Example extends PureComponent {
  static demoUrl = "https://codesandbox.io/s/bar-chart-with-double-xaxis-dfug7";

  render() {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={250}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          {/* <XAxis dataKey="date" tickFormatter={monthTickFormatter} /> */}
          <XAxis dataKey="date" />
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            interval={0}
            // tick={renderQuarterTick}
            height={1}
            scale="band"
            xAxisId="quarter"
          />
          <YAxis />
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="pv" fill="#15B0BC" width={5} />
          {/* <Bar dataKey="uv" fill="#187e85" width={5} /> */}
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
